<template>
  <div class="one-element-form-select" :class="[{disabled: disabled}, `mode-${mode}`]">
    <!-- <div
    class='label'
    v-if="label"
  >
    <span v-html="label"></span>
  </div> -->

    <OneLabel :text="label" v-if="label" />

    <div class="selected-option" @click="toggleOpen()">
      <label class="select-label" v-if="selectedOption && selectedOption.name">{{
        getOptionName(selectedOption.name)
      }}</label>
      <label class="select-label" v-if="!selectedOption">---</label>

      <!-- <div class='arrow' >
      <OneIcon icon="ChevronDown" v-if="!open" key='chevron-down' />
      <OneIcon icon="ChevronUp" v-if="open" key='chevron-up' />
    </div> -->
      <OneButtonFold v-show="!this.disabled && this.mode == 'edit'" :folded="open" />
    </div>

    <div class="options" v-if="open">
      <div
        class="item"
        v-for="option in options"
        :class="{selected: modelValue == option.value}"
        :key="`option-${valueKey ? option.value[valueKey] : option.value}`"
        @click="selectOption(option.value)"
      >
        <div class="radio-wrap">
          <label class="select-label" v-if="option.key" v-localize="{key: option.key}"></label>
          <label class="select-label" v-if="option.name">{{ getOptionName(option.name) }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {v4 as uuidv4} from "uuid"
export default {
  name: "OneSelect",
  props: {
    modelValue: {
      type: [Object, String, Number],
    },
    // allows values to be objects
    valueKey: {
      type: [String, Boolean],
      default: false,
    },
    path: {
      type: String,
    },
    label: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: String,
      default: "edit",
    },
    size: {
      type: [String, Number],
      default: "m",
    },
    currentLang: {
      type: String,
    },
  },
  emits: ["update:modelValue"],
  setup() {
    const componentUid = uuidv4()

    return {
      componentUid,
    }
  },
  data() {
    return {
      open: false,
    }
  },
  computed: {
    currentValue() {
      return this.modelValue && this.path ? this.modelValue[this.path] : this.modelValue
    },
    selectedOption() {
      return this.options.find((o) =>
        this.valueKey
          ? o.value[this.valueKey] == this.currentValue[this.valueKey]
          : o.value == this.currentValue
      )
    },
  },
  created() {},
  methods: {
    toggleOpen() {
      if (this.disabled) return false
      this.open = !this.open
    },
    getOptionName(name) {
      if (typeof name === "object" && name !== null && this.currentLang) {
        return name[this.currentLang]
      } else {
        return name
      }
    },
    selectOption(value) {
      if (this.disabled) return false
      // console.log('selectOption', value)
      this.open = false

      // write to supplied object
      if (this.modelValue && this.path) {
        this.modelValue[this.path] = value
        this.$emit("update:modelValue", value, {
          fieldId: this.componentUid,
        })
      }
      // return only
      else {
        console.log("selectOption()", value)
        this.$emit("update:modelValue", value, {
          fieldId: this.componentUid,
        })
      }
    },
  },
}
</script>

<style scoped lang="less">
@import "../../../variables.less";
.one-element-form-select {
  position: relative;

  &.disabled {
    .selected-option {
      cursor: not-allowed;
      background: none;
      border: 1px solid @pfm-color-neutral-300;

      label.select-label {
        color: @pfm-color-neutral-500;
      }

      &:hover {
        background: none;
      }
    }
  }

  &.mode-view {
    .selected-option {
      background: none;
      pointer-events: none;
      padding: 0 0 0 8px;

      label.select-label {
        color: @pfm-color-neutral-900;
      }
    }
  }

  // .label {
  //     text-align: center;
  //     width: 100%;
  //     padding: 15px 0 10px;
  //     font-weight: bold;
  //     text-transform: uppercase;
  //     letter-spacing: 0.1rem;
  //     font-size: 0.8rem;
  //     display: block;
  //
  //     span {}
  // }

  span.label {
    padding-left: 8px;
    color: @pfm-color-neutral-600;
  }

  .selected-option {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    background-color: @pfm-color-neutral-300;
    border-radius: 7px;
    margin: 4px 0;
    cursor: pointer;
    overflow: hidden;
    padding: 14px;

    &:hover {
      background-color: @pfm-color-neutral-400;
    }
  }

  .options {
    background-color: @pfm-color-neutral-300;
    border-radius: 7px;
    position: absolute;
    width: 100%;
    z-index: 900;
    max-height: 200px;
    overflow-y: scroll;

    .item {
      width: 100%;
      // padding: 20px;
      // background-color: @pfm-color-neutral-300;
      margin: 0 0 0 0;
      cursor: pointer;
      overflow: hidden;

      &:first {
        border-top-left-radius: 7px;
        border-top-right-radius: 7px;
      }

      &:last {
        border-bottom-left-radius: 7px;
        border-bottom-right-radius: 7px;
      }

      &:hover {
        background-color: @pfm-color-neutral-400;
      }

      &.selected {
        background-color: @pfm-color-neutral-700;
        height: auto;

        label.select-label {
          color: #ffffff;
        }

        .radio-wrap {
        }
      }

      &.disabled {
        background-color: @pfm-color-neutral-100;
        cursor: not-allowed;

        label.radio-label {
          color: @pfm-color-neutral-400;
        }

        .radio-wrap {
        }
      }

      .radio-wrap {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        padding: 14px;

        .multiple-lines {
          .delivery-place {
            font-size: 0.75rem;
            display: block;
            color: @pfm-color-neutral-500;
            letter-spacing: 0;
          }
        }
      }

      input {
        display: none;
      }
    }
  }

  label.select-label {
    font-size: 1rem;
    font-weight: 400;
    letter-spacing: 0.05rem;
    color: @pfm-color-neutral-700;
    pointer-events: none;
    text-transform: none;
  }
}
</style>
